import React from "react";
import { Stack, TextField } from "@fluentui/react";
import { useTheme } from "../../../theme/OAS365Theme";
import { useCommonControlsStyle } from "../../../theme/styles/CommonControlsStyle";
import RevisionDocumentAutocomplete from "./RevisionDocumentAutocomplete.jsx";
import FieldValidationMessage from "../../../components/checkinDocuments/FieldValidationMessage";

/**
 * Document No (with search) and Title fields for check-in new revision.
 */
function RevisionDocumentFields({
  selectedRevisionItem,
  onSelectRevisionItem,
  onClearSelection,
  showFieldValidation = true,
  documentError = "",
  focusToken = 0,
}) {
  const theme = useTheme();
  const styleTheme = useCommonControlsStyle();

  const title =
    selectedRevisionItem != null && selectedRevisionItem?.title != null
      ? selectedRevisionItem.title
      : "";

  return (
    <>
      <RevisionDocumentAutocomplete
        selectedRevisionItem={selectedRevisionItem}
        onSelectRevisionItem={onSelectRevisionItem}
        onClearSelection={onClearSelection}
        showFieldValidation={showFieldValidation}
        fieldError={documentError}
        focusToken={focusToken}
      />

      <Stack.Item grow style={{ marginTop: "10px", width: "100%" }}>
        <Stack tokens={{ marginTop: 10 }}>
          <span
            style={{
              fontFamily: theme.fonts.regular,
              fontSize: theme.fontSizes.normal,
            }}
          >
            Title
            <span style={{ color: theme.colors.fontColor }}> *</span>
          </span>
          <TextField
            styles={styleTheme.TextFiledsStyle}
            value={title}
            disabled={true}
          />
        </Stack>
      </Stack.Item>
    </>
  );
}

export default RevisionDocumentFields;
